import classNames from "classnames";
import { forwardRef, ReactNode, Ref } from "react";

export type RadioInputProps = {
  label?: ReactNode;
  labelClassName?: string;
  containerClassName?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const RadioInput = forwardRef(function RadioInput({
  type,
  label,
  labelClassName,
  className,
  containerClassName,
  ...props
}: RadioInputProps, ref: Ref<HTMLInputElement>) {
  const classes = classNames(
    "border-gray-300 shadow-sm mr-1 -mt-1 form-radio text-primary",
    "disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none",
    className,
  );

  return (
    <div className={classNames("w-fit min-w-max inline-block", containerClassName)}>
      <label className={labelClassName}>
        <input
          {...props}
          ref={ref}
          type="radio"
          className={classes}
        />
        {label}
      </label>
    </div>
  );
});
